import { useEffect } from 'react'
import { getOfflineQueue, clearOfflineQueue, removeFromQueue } from '../../lib/offlineQueue'

async function syncQueue() {
  const queue = getOfflineQueue()
  if (queue.length === 0) return

  const { createBooking } = await import('../../lib/api')
  for (let i = 0; i < queue.length; i++) {
    try {
      await createBooking(queue[i])
      removeFromQueue(0)
    } catch {
      break
    }
  }
}

export function OfflineSync() {
  useEffect(() => {
    const handleOnline = () => {
      syncQueue()
    }
    window.addEventListener('online', handleOnline)
    if (navigator.onLine) syncQueue()
    return () => window.removeEventListener('online', handleOnline)
  }, [])
  return null
}
